import { useState } from 'react';
import { Button, mergeClasses, Spinner, Text } from '@fluentui/react-components';
import { useLocation, useNavigate } from 'react-router-dom';

import { RoutePaths } from 'src/utils/enums';
import { useStore } from 'src/hooks/useStore';
import { useSignInFormStyles } from './SignInForm.styles';

interface SignInFormProps {
  className?: string
}

const SignInForm: React.FC<SignInFormProps> = ({ className }) => {
  const { authStore } = useStore();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null as unknown);
  const styles = useSignInFormStyles();
  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from ?? RoutePaths.Dashboard;
  const signInFormId = 'sign-in-form';

  if (error) {
    throw error;
  }

  const onSignIn = async (): Promise<void> => {
    try {
      setIsLoading(true);
      await authStore.signIn('');
      navigate(from);
    }
    catch (error: unknown) {
      setError(error);
    }
    finally {
      setIsLoading(false);
    }
  };

  const getSignInText = isLoading
    ? (
      <>
        {'Signing in... '}
        <Spinner size="extra-tiny" className={styles.spinner} />
      </>
    )
    : (
      'Sign in'
    );

  return (
    <div className={mergeClasses(signInFormId, styles.container, className)} data-testid={signInFormId}>
      <Text className={styles.title}>Welcome to WebMD ONE</Text>
      <Text className={styles.text}>Please sign in to the WebMD ONE system to access its features.</Text>
      <Button
        appearance="primary"
        onClick={onSignIn}
        data-testid="sign-in-btn"
        disabled={isLoading}
        aria-busy={isLoading}
        aria-live="polite"
      >
        {getSignInText}
      </Button>
    </div>
  );
};

export default SignInForm;
